import React from 'react';
import { DrawerHeader } from './DrawerHeader';
import { makeStyles, Divider, Drawer } from '@material-ui/core';

const drawerWidth = 350;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        '& > div': {
            marginTop: 8,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
    contentContainer: {
        width: '100%',
        maxWidth: props => props.contentWidth,
        padding: theme.spacing(2),
        margin: 'auto',
    },
    main: {
        marginTop: theme.spacing(2),
    },
    topLine: {
        height: 8,
        width: '100%',
        background: `linear-gradient(90deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
        position: 'fixed',
        zIndex: 20,
    },
    header: {
        marginTop: theme.spacing(2),
        marginBottom: 50,
    },
}));

export interface LayoutProps {
    drawerHeader?: React.ReactNode;
    drawerContent?: React.ReactNode;
    header: React.ReactNode;
    breadcrumb?: React.ReactNode;
    noDrawer?: boolean;
    width?: number;
    children?: React.ReactNode;
}

export const Layout: React.FunctionComponent<LayoutProps> = props => {
    const {
        drawerHeader = <DrawerHeader title="" />,
        noDrawer = false,
        width = 600,
    } = props;

    const classes = useStyles({ contentWidth: width });

    return (
        <>
            <div className={classes.topLine}></div>
            <div className={classes.root}>
                {!noDrawer && (
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        anchor="left"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        {drawerHeader}
                        {props.drawerContent && (
                            <>
                                <Divider />
                                {props.drawerContent}
                            </>
                        )}
                    </Drawer>
                )}
                <div className={classes.contentContainer}>
                    {props.header && (
                        <header className={classes.header}>
                            {props.breadcrumb}
                            {props.header}
                        </header>
                    )}
                    <main className={classes.main}>
                        {props.children}
                    </main>
                </div>
            </div>
        </>
    );
};
